import { UNFORMATTED } from 'customer-data-objects/property/NumberDisplayHint';
import DisplayValueCurrency from './DisplayValueCurrency';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueNumber = props => {
  const {
    operator,
    value
  } = props;
  const {
    numberDisplayHint,
    showCurrencySymbol
  } = operator.field || {};
  const currencyCode = showCurrencySymbol ? props.currencyCode : undefined;
  if (showCurrencySymbol) {
    return /*#__PURE__*/_jsx(DisplayValueCurrency, {
      currencyCode: currencyCode,
      simplifyCurrency: true,
      value: value
    });
  }
  if (numberDisplayHint !== UNFORMATTED) {
    return /*#__PURE__*/_jsx(FormattedNumber, {
      value: value
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: value
  });
};
export default /*#__PURE__*/memo(DisplayValueNumber);